// extracted by mini-css-extract-plugin
module.exports = {"goBack":"styles-module--goBack--3a9uf","preview":"styles-module--preview--1e7aM"};